import { Stack, SkeletonCircle } from '@chakra-ui/react';
import Skeleton from '../../Skeleton';
import Grid from '../../Grid';
import styles from './styles';
import ServiceProfileCard from '../ServiceProfileCard/ServiceProfileCard';
export default function ServiceProfileCardPlaceholder({
    rows,
    columns,
    items,
    ...props
}) {
    return (
        <Grid rows={rows} columns={columns} gap={4} {...props}>
            {Array.from(Array(items)).map((v, index) => (
                <ServiceProfileCard key={`service-profile-card-${index}`}>
                    <Stack>
                        <SkeletonCircle size="10" sx={styles.skeletonCircle} />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                    </Stack>
                </ServiceProfileCard>
            ))}
        </Grid>
    );
}
